var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{staticClass:"bottom-button",class:{ 'bottom-button--active': _vm.active },attrs:{"wide":"","primary":""},nativeOn:{"click":function($event){return _vm.clickHandler($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }